/* eslint-disable functional/no-conditional-statement */
import { addSignInInfoEventListener } from "../../sign-in/miscellaneous/addSignInInfoEventListener";
import { getCode } from "../../sign-in/miscellaneous/getCode";
import { getSignInResponse } from "../../sign-in/miscellaneous/getSignInResponse";
import { setupInterceptTokenHack } from "../../sign-in/miscellaneous/setupInterceptTokenHack";

export async function initSignIn() {
  addSignInInfoEventListener();
  // hacky tacked on fix for `setupInterceptTokenHack` "audience" error
  setupInterceptTokenHack();

  // Check if a code value return from oidc then dispatch Signin infor event to get token
  if (!!getCode()) {
    await getSignInResponse();
  }
}
